import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ProjectOutlined,
  CalendarOutlined,
  ToolOutlined,
  SafetyCertificateOutlined,
  DashboardOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <CalendarOutlined />,
  1: <ToolOutlined />,
  2: <SafetyCertificateOutlined />,
  3: <DashboardOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("mes");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-mes-section dev-mes-highlights-section">
      <div className="dev-mes-section-inner">
        <h2 className="dev-section-h2 dev-mes-section-h2">
          <span className="dev-mes-section-h2-icon dev-mes-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-mes-highlights-grid">
          <div className="dev-mes-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-mes-highlight-item">
                <div className="dev-mes-highlight-icon">
                  {iconByIndex[idx] ?? <ProjectOutlined />}
                </div>
                <div>
                  <div className="dev-mes-highlight-title">{item.title}</div>
                  <div className="dev-mes-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-mes-stat-card dev-mes-stat-card--ontime">
            <div className="dev-mes-stat-value">{statValue}</div>
            <div className="dev-mes-stat-label">{statLabel}</div>
            <div className="dev-mes-stat-desc">{statDesc}</div>
            <div className="dev-mes-stat-badge">{t("highlights.stat_badge")}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
